import { render, staticRenderFns } from "./CookieBanner.vue?vue&type=template&id=3868e32c&scoped=true&"
import script from "./CookieBanner.vue?vue&type=script&lang=ts&"
export * from "./CookieBanner.vue?vue&type=script&lang=ts&"
import style0 from "./CookieBanner.vue?vue&type=style&index=0&id=3868e32c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3868e32c",
  null
  
)

export default component.exports